import type { Sticker } from '../types';

export const vegetables: Sticker[] = [
  {
    id: 14001,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/001-broccoli.png',
    name: 'Brokuł',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14002,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/002-mushroom.png',
    name: 'Grzyb',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14003,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/003-harvest.png',
    name: 'Zbiory Warzyw',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14004,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/004-harvest.png',
    name: 'Koszyk Warzyw',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14005,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/005-woman.png',
    name: 'Pani z Warzywami',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14006,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/006-radish.png',
    name: 'Rzodkiewka',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14007,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/007-carrot.png',
    name: 'Marchewka',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14008,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/008-boy.png',
    name: 'Chłopiec z Warzywami',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14009,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/009-potatoe.png',
    name: 'Ziemniak',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14010,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/010-tomato.png',
    name: 'Pomidor',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14011,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/011-vegetables.png',
    name: 'Warzywa',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14012,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/012-corn.png',
    name: 'Kukurydza',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14013,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/013-tomatoes.png',
    name: 'Pomidory',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14014,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/014-vegetables.png',
    name: 'Świeże Warzywa',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14015,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/015-vegetables.png',
    name: 'Warzywa w Koszyku',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14016,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/016-pumpkin.png',
    name: 'Dynia',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14017,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/017-vegetables.png',
    name: 'Zdrowe Warzywa',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14018,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/018-eggplant.png',
    name: 'Bakłażan',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14019,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/019-vegetables.png',
    name: 'Warzywa na Talerzu',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 14020,
    url: 'https://stickers.nauczniaczek.pl/colections/13483164-vegetables/png/020-vegetables.png',
    name: 'Sałatka Warzywna',
    category: 'vegetables',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];